import { createAction, props } from '@ngrx/store';
import { EnergyStarItem } from '../../model/energy-star-item.model';
import { EnergyStarSubmissionRequest } from '../../services/energy-star-submission.service';

export const loadEnergyStarItems = createAction('[Energy Star Items] Load Energy Star Items', props<{ facilityGroupId: number; year: number }>());

export const loadEnergyStarItemsHistory = createAction('[Energy Star Items] Load Energy Star Items History', props<{ facilityGroupId: number }>());

export const loadEnergyStarItemsSuccess = createAction('[Energy Star Items] Load Energy Star Items Success', props<{ energyStarItems: EnergyStarItem[] }>());

export const loadEnergyStarItemsError = createAction('[Energy Star Items] Load Energy Star Items Error', props<{ error: Error }>());

export const clearEnergyStarItems = createAction('[Energy Star Items] Clear Energy Star Items');

export const submitEnergyStarApplication = createAction(
  '[Energy Star Submission] Submit Application',
  props<{ facilityId: string; submission: EnergyStarSubmissionRequest; facilityGroupId: number; year: number }>(),
);

export const submitEnergyStarApplicationSuccess = createAction(
  '[Energy Star Submission] Submit Application Success',
  props<{ submissionId: string; facilityGroupId: number; year: number }>(),
);

export const submitEnergyStarApplicationError = createAction('[Energy Star Submission] Submit Application Error', props<{ error: string }>());

export const clearEnergyStarSubmissionError = createAction('[Energy Star Submission] Clear Submission Error');

export const updateEnergyStarStatus = createAction(
  '[Energy Star Status] Update Status',
  props<{ facilityId: string; facilityGroupId: number; year: number }>(),
);

export const updateEnergyStarStatusSuccess = createAction(
  '[Energy Star Status] Update Status Success',
  props<{ facilityId: string; facilityGroupId: number; year: number }>(),
);

export const updateEnergyStarStatusError = createAction('[Energy Star Status] Update Status Error', props<{ error: string }>());
